import React from 'react';
import {
  Box, TextField, FormControlLabel, Switch, Typography,
  ToggleButtonGroup, ToggleButton, Stack, Paper, InputAdornment
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InstagramIcon from '@mui/icons-material/Instagram';
import FacebookIcon from '@mui/icons-material/Facebook';
import LinkedInIcon from '@mui/icons-material/LinkedIn';
import EmailIcon from '@mui/icons-material/Email';
import SmsIcon from '@mui/icons-material/Sms';
import LocalPostOfficeIcon from '@mui/icons-material/LocalPostOffice';

const INVITE_METHODS = [
  { value: 'whatsapp', label: 'WhatsApp', icon: <WhatsAppIcon fontSize="small" /> },
  { value: 'sms', label: 'SMS', icon: <SmsIcon fontSize="small" /> },
  { value: 'email', label: 'Email', icon: <EmailIcon fontSize="small" /> },
  { value: 'printed', label: 'Printed Card', icon: <LocalPostOfficeIcon fontSize="small" /> },
];

const ContactInfo = ({ data = {}, onChange, readOnly = false }) => {
  const ro = readOnly ? { readOnly: true } : {};
  const roSx = readOnly ? { '& .MuiInputBase-root': { bgcolor: 'grey.100' } } : {};
  return (
  <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
    {/* Alternate phone + WhatsApp */}
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Typography variant="subtitle2" fontWeight={600} mb={1.5}>Alternate Contact</Typography>
      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2} alignItems="center">
        <TextField
          label="Alternate Phone"
          value={data.alternate_phone || ''}
          onChange={e => { if (!readOnly) onChange('alternate_phone', e.target.value); }}
          fullWidth
          placeholder="+44 7000 000000"
          InputProps={ro}
          sx={roSx}
        />
        <FormControlLabel
          control={
            <Switch
              checked={!!data.whatsapp_enabled}
              onChange={e => { if (!readOnly) onChange('whatsapp_enabled', e.target.checked); }}
              color="success"
              disabled={readOnly}
            />
          }
          label={
            <Stack direction="row" spacing={0.5} alignItems="center">
              <WhatsAppIcon fontSize="small" sx={{ color: '#25D366' }} />
              <Typography variant="body2">WhatsApp</Typography>
            </Stack>
          }
        />
      </Stack>
    </Paper>

    {/* Social media */}
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Typography variant="subtitle2" fontWeight={600} mb={1.5}>Social Media</Typography>
      <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
        <TextField
          label="Instagram"
          value={data.instagram_handle || ''}
          onChange={e => { if (!readOnly) onChange('instagram_handle', e.target.value); }}
          fullWidth
          placeholder="@username"
          InputProps={{ ...ro, startAdornment: <InputAdornment position="start"><InstagramIcon fontSize="small" /></InputAdornment> }}
          sx={roSx}
        />
        <TextField
          label="Facebook"
          value={data.facebook_url || ''}
          onChange={e => { if (!readOnly) onChange('facebook_url', e.target.value); }}
          fullWidth
          placeholder="facebook.com/yourname"
          InputProps={{ ...ro, startAdornment: <InputAdornment position="start"><FacebookIcon fontSize="small" /></InputAdornment> }}
          sx={roSx}
        />
        <TextField
          label="LinkedIn"
          value={data.linkedin_url || ''}
          onChange={e => { if (!readOnly) onChange('linkedin_url', e.target.value); }}
          fullWidth
          placeholder="linkedin.com/in/yourname"
          InputProps={{ ...ro, startAdornment: <InputAdornment position="start"><LinkedInIcon fontSize="small" /></InputAdornment> }}
          sx={roSx}
        />
      </Box>
    </Paper>

    {/* Preferred invite method */}
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Typography variant="subtitle2" fontWeight={600} mb={1.5}>Preferred Invitation Method</Typography>
      <ToggleButtonGroup
        value={data.invite_method || 'whatsapp'}
        exclusive
        onChange={(_, v) => { if (!readOnly && v) onChange('invite_method', v); }}
        sx={{ flexWrap: 'wrap', gap: 1 }}
        disabled={readOnly}
      >
        {INVITE_METHODS.map(m => (
          <ToggleButton key={m.value} value={m.value} sx={{ gap: 0.5, borderRadius: '20px !important', border: '1px solid !important' }}>
            {m.icon} {m.label}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
    </Paper>
  </Box>
  );
};

export default ContactInfo;
